export default "__VITE_ASSET__CyAnJ1fV__"